export default __webpack_public_path__ + "3011237ba52b39fe50311f7917878ace.jpg";